import React from 'react';
import { Element } from './FormLoader.styles';
import { Text } from '@/components/typography';
import { Spinner } from '@/components/loading';
import Fieldset from '@/components/form/Fieldset/Fieldset';

export interface FormLoaderProps {}

const FormLoader = ({ ...props }: FormLoaderProps) => {
  return (
    <Fieldset size="lg" align="center" flex>
      <Element>
        <Spinner>
          <Text size="md" weight="bold" align="center">
            Enviando sua mensagem, por favor, aguarde...
          </Text>
        </Spinner>
      </Element>
    </Fieldset>
  );
};

export default FormLoader;
